import PropTypes from 'prop-types';

import Block from 'shopper/components/Block';
import Breadcrumb from 'shopper/components/Breadcrumb';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import { toCategoryLink, toSubcategoryLink } from 'lib/links';
import { sliceWithEllipsis } from 'lib/string';

import APP from 'constants/app';

const OFFER_TITLE_CHAR_LIMIT = 48;

const OfferBreadcrumb = ({
  categoryName,
  categorySlug,
  offerTitle,
  subcategoryName,
  subcategorySlug,
}) => (
  <Block Block mx={[4, null, 0]}>
    <Breadcrumb>
      <BreadcrumbItem href="/">{APP.BREADCRUMB_FIRST_ITEM}</BreadcrumbItem>
      <BreadcrumbItem href={toCategoryLink(categorySlug)}>
        {categoryName}
      </BreadcrumbItem>
      {subcategoryName && (
        <BreadcrumbItem href={toSubcategoryLink(subcategorySlug)}>
          {subcategoryName}
        </BreadcrumbItem>
      )}
      {offerTitle && (
        <BreadcrumbItem>
          {sliceWithEllipsis(offerTitle, OFFER_TITLE_CHAR_LIMIT)}
        </BreadcrumbItem>
      )}
    </Breadcrumb>
  </Block>
);

OfferBreadcrumb.defaultProps = {
  subcategoryName: null,
  offerTitle: null,
};

OfferBreadcrumb.propTypes = {
  categoryName: PropTypes.string.isRequired,
  categorySlug: PropTypes.string.isRequired,
  offerTitle: PropTypes.string,
  subcategoryName: PropTypes.string,
  subcategorySlug: PropTypes.string.isRequired,
};

export default OfferBreadcrumb;
